import styled from 'styled-components';

export const ContentWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	margin-top: 56px;
	gap: 24px;
	padding-left: 6%;
	padding-right: 3%;

	@media screen and (max-width: ${({ theme }) => theme.breakpoints.sm}) {
		margin-top: 15px;
	}
`;
